<template>
    <div class="campaign-header element-relative">
        <div class="campaign-header-image">
            <ImageLazy
                :image-url="imageUrl"
                :height="409"
                :is-background="true"
                alt=""
                class="campaign-header-image-desktop"
            />
            <ImageLazy
                :image-url="imageUrl"
                :height="500"
                :is-background="true"
                alt=""
                class="campaign-header-image-mobile"
            />
        </div>
        <div class="campaign-header-body wrapper flex flex-column flex-content-center flex-unset-align">
            <Typo theme="paddingless">
                <header class="fs-32 fs-lh-40 text-color-contrast">
                    <strong>Dowiedz się jako pierwszy</strong><br>
                    o najlepszych promocjach
                </header>
            </Typo>
            <Typo
                :html="bodyHtml"
                :theme="[
                    'color-contrast',
                    'paddingless'
                ]"
            />
            <CampaignHeaderIcons />
        </div>
    </div>
</template>

<script>
import CampaignHeaderIcons from './CampaignHeaderIcons'

export default {
    components: { CampaignHeaderIcons },
    props: {
        bodyHtml: {
            type: String,
            required: false,
            default: ''
        },
        imageUrl: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.campaign-header {
    min-height: 409px;

    &-image {
        @include position-cover();
        z-index: 1;

        > .image-lazy {
            > * {
                > * {
                    background-position-x: right;
                }
            }
        }

        &-mobile {
            display: none;
        }

        @media (min-width: $screen-laptop + 1px) {
            &:after {
                display: none;
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 61%;
                background: linear-gradient(to right, rgba(17, 17, 17, 1), rgba(17, 17, 17, 1), rgba(17, 17, 17, 0));
            }
        }
    }

    &-body {
        position: relative;
        height: 409px;
        padding-top: 25px;
        z-index: 2;

        .is-ie & {
            display: block;
        }
    }

    .typo {
        max-width: 510px;

        p,
        ul > li,
        ol > li {
            font-size: 1.6rem;
            line-height: 1.9rem;
            margin-bottom: 23px;
        }

        &-list {
            > li {
                &:nth-child(n + 2) {
                    margin-top: 0;
                }
            }
        }
    }

    @media (max-width: $screen-page) {
        &-image {
            > .image-lazy {
                > * {
                    > * {
                        background-position-x: 83%;
                    }
                }
            }
        }
    }

    @media (max-width: $screen-laptop) {
        &-body {
            background-color: rgba($color-default, .4);
        }

        &-image {
            > .image-lazy {
                > * {
                    > * {
                        background-position-x: 73%;
                    }
                }
            }
        }
    }

    @media (max-width: $screen-tablet) {
        &-body {
            height: 500px;
        }

        &-image {
            &-desktop {
                display: none;
            }

            &-mobile {
                display: block;
            }
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        &-body {
            .typo {
                header {
                    &[class^=fs-] {
                        font-size: 2.0rem;
                        line-height: 2.7rem;
                    }
                }

                ol {
                    > li {
                        font-size: 1.6rem;
                        line-height: 2.5rem;
                        margin-bottom: 10px;
                    }
                }

                .fs-50 {
                    font-size: 4rem;
                    line-height: 4.5rem;
                }
            }
        }
    }
    @media (max-width: $screen-mobile-extra-large) {
        &-body {
            .typo {
                ol {
                    > li {
                        font-size: 1.6rem;
                        line-height: 2rem;
                    }
                }

                .fs-50 {
                    font-size: 3rem;
                    line-height: 3.5rem;
                }
            }
        }
    }
}
</style>
